import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import { currentActorContextPropsStructure } from 'components/contexts/CurrentActor';
import ProjectDocumentsTab from 'components/projectDocuments/ProjectDocumentsTab';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function ProjectDocumentsApp({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <ProjectDocumentsTab {...wrappedProps} />
      </AppWrapper>
    </QueryClientProvider>
  );
}

ProjectDocumentsApp.propTypes = {
  contextProps: PropTypes.shape({
    actors: PropTypes.exact(currentActorContextPropsStructure).isRequired,
  }),
  wrappedProps: PropTypes.shape({
    procoreProjectIntegration: PropTypes.shape({
      data: resourceShape('procoreProjectIntegration'),
    }),
    project: PropTypes.shape({
      data: resourceShape('simpleProject'),
    }).isRequired,
    riskAssessmentOnlyAccess: PropTypes.bool.isRequired,
  }).isRequired,
};
